import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface ResponsiveFormProps {
  children: ReactNode;
  className?: string;
  layout?: "single" | "two-column" | "adaptive";
}

export function ResponsiveForm({
  children,
  className,
  layout = "adaptive",
}: ResponsiveFormProps) {
  const layoutClasses = {
    single: "space-y-4",
    "two-column": "grid grid-cols-1 sm:grid-cols-2 gap-4",
    adaptive: "space-y-4 sm:space-y-6",
  };

  return (
    <form className={cn(layoutClasses[layout], className)}>{children}</form>
  );
}

interface ResponsiveFormGroupProps {
  children: ReactNode;
  columns?: 1 | 2 | 3;
  className?: string;
}

export function ResponsiveFormGroup({
  children,
  columns = 1,
  className,
}: ResponsiveFormGroupProps) {
  const columnClasses = {
    1: "space-y-4",
    2: "grid grid-cols-1 sm:grid-cols-2 gap-4",
    3: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4",
  };

  return (
    <div className={cn(columnClasses[columns], className)}>{children}</div>
  );
}
